import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { API_BASE } from '../config';
import './EventsPage.css';

const EventsPage = () => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/events?status=upcoming`)
      .then(res => res.json())
      .then(data => setUpcomingEvents(data))
      .catch(() => {});

    fetch(`${API_BASE}/events?status=past`)
      .then(res => res.json())
      .then(data => setPastEvents(data))
      .catch(() => {});
  }, []);

  const events = activeTab === 'upcoming' ? upcomingEvents : pastEvents;

  return (
    <div className="evt-page">
      <section className="evt-page-hero">
        <div className="evt-page-hero-content">
          <span className="evt-page-hero-badge">Organizasyonlar & Programlar</span>
          <h1 className="evt-page-hero-title">Etkinlikler</h1>
          <p className="evt-page-hero-desc">Yaklaşan ve geçmiş etkinliklerimizi keşfedin</p>
        </div>
      </section>

      <section className="evt-page-content">
        <div className="evt-page-container">
          <div className="evt-page-tabs">
            <button
              className={`evt-page-tab ${activeTab === 'upcoming' ? 'active' : ''}`}
              onClick={() => setActiveTab('upcoming')}
            >
              Gelecek Etkinlikler ({upcomingEvents.length})
            </button>
            <button
              className={`evt-page-tab ${activeTab === 'past' ? 'active' : ''}`}
              onClick={() => setActiveTab('past')}
            >
              Geçmiş Etkinlikler ({pastEvents.length})
            </button>
          </div>

          {events.length === 0 ? (
            <div className="evt-page-empty">
              {activeTab === 'upcoming' ? 'Yaklaşan etkinlik bulunmamaktadır.' : 'Geçmiş etkinlik bulunmamaktadır.'}
            </div>
          ) : (
            <div className="evt-page-grid">
              {events.map(event => (
                <Link to={`/${event.slug}`} className="evt-page-card" key={event._id}>
                  <div className="evt-page-card-image">
                    {event.image && <img src={event.image} alt={event.title} />}
                    <div className="evt-page-card-overlay"></div>
                    <span className={`evt-page-card-tag ${event.status === 'past' ? 'evt-page-card-tag--past' : ''}`}>
                      {event.status === 'upcoming' ? 'Yaklaşan' : 'Tamamlandı'}
                    </span>
                  </div>
                  <div className="evt-page-card-body">
                    <h3 className="evt-page-card-title">{event.title}</h3>
                    {event.description && <p className="evt-page-card-desc">{event.description}</p>}
                    <div className="evt-page-card-meta">
                      {event.date && <span><FaCalendarAlt /> {event.date}</span>}
                      {event.time && <span><FaClock /> {event.time}</span>}
                      {event.location && <span><FaMapMarkerAlt /> {event.location}</span>}
                    </div>
                    <span className="evt-page-card-link">
                      Detaylar <FaArrowRight />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default EventsPage;
